<div class="section_wrapper">
    <h1 id="privacyPolicy">Privacy Policy</h1>
    <br>
    <h4>1. Introduction</h4>
    <br>
    <p>We appreciate your interest in our app. Protecting your personal data is very important to us. Below, we provide detailed information about how we handle your data.</p>
    <br>
    <h4>2. Responsible Entity</h4>
    <br>
    <p>The following individuals are responsible for data processing in this app:</p>
    <br>
    <p>Catalina Acosta Rivera</p>
    <p>Caryen Song</p>
    <p>Albina Januzi</p>
    <p>Barbora Lambeinova</p>
    <p>For more information, please refer to our <a [routerLink]="['/imprint']">Imprint</a>.</p>
    <br>
    <h4>3. Collection and Use of Data</h4>
    <br>
    <p>We collect and use your personal data only when legally permitted or when you have given your consent for data collection and processing.</p>
    <br>
    <h5>3.1 Personal Data</h5>
    <p>Personal data refers to information that can be used to identify a person, such as name, email address, or IP address. Generally, we require this data when you contact us via a contact form or use certain features of the app.</p>
    <br>
    <h5>3.2 Automatic Data Collection</h5>
    <p>When accessing our app, the following data is automatically stored in so-called server log files:</p>
    <br>
    <p>Your IP address</p>
    <p>Date and time of access</p>
    <p>Referrer URL (the previously visited page)</p>
    <p>Information about the browser used (e.g., version, language)</p>
    <p>This data is technically necessary to provide the app and is not used to identify individual persons.</p>
    <br>
    <h4>4. Use of Cookies</h4>
    <br>
    <p>Our app uses cookies to improve the user experience. Cookies are small text files stored on your device. You can disable the use of cookies at any time in your device settings. Please note that some features of the app may no longer be available if you disable cookies.</p>
    <br>
    <h4>5. Data Sharing with Third Parties</h4>
    <br>
    <p>We do not share your data with third parties unless this is necessary to fulfill a contract or we are legally required to do so. In such cases, we ensure that third parties use the data in compliance with applicable data protection regulations.</p>
    <br>
    <h4>6. Data Security</h4>
    <br>
    <p>We implement technical and organizational security measures to protect your data from loss, misuse, or unauthorized access. However, despite all precautions, no data transmission over the internet can be completely secure, and we cannot guarantee the security of transmitted data.</p>
    <br>
    <h4>7. Your Rights</h4>
    <br>
    <p>You have the right to request information about your stored personal data at any time. Additionally, you can request the correction, deletion, or restriction of the processing of your data. You also have the right to object to the processing of your data.</p>
    <br>
    <p>If you have questions about the processing of your personal data or wish to exercise your rights, you can contact us using the information provided above.</p>
    <br>
    <h4>8. Changes to the Privacy Policy</h4>
    <br>
    <p>We reserve the right to modify this privacy policy at any time to comply with new legal requirements or changes in our services. The current version of the privacy policy is available in the app.</p>
    <br>
    <h4>9. Contact</h4>
    <br>
    <p>If you have any questions about this privacy policy or the processing of your personal data, you can contact us:</p>
    <br>
    <p>Barbora Lambeinova</p>
    <p>lambeinovab&#64;seznam.cz</p>
    <br>
    <p>Albina Januzi</p>
    <p>albina_januzi&#64;hotmail.com</p>
    <br>
    <p>Caryen Song</p>
    <p>caryensong&#64;googlemail.com</p>
    <br>
    <p>Catalina Acosta Rivera</p>
    <p>catalina.acosta.rivera&#64;gmail.com</p>
</div>
